import React, { useState } from "react";
import ReactQuill from "react-quill";
import { CreatePitchApi, SeheduleApiCreate } from "../../../services/apis/EventMangement/CreateEventApi";

const Pitch = ({ eventId, setTabValue }) => {
    const [input, setInput] = useState({
        programme_details: '',
        exhibitors_and_participants: ''
    });


    const [exhibitorList, setExhibitorList] = useState([]);
    const [speakerList, setSpeakerList] = useState({
        name: "",
        photo: null,
    });
    const [errors, setErrors] = useState({});
    const [normalEdit, setNormalEdit] = useState(false);
    const [confirmedSponsorId, setConfirmedSponsorId] = useState(null);

    const handleOnchange = (e) => {
        const { name, value } = e.target;
        setInput({ ...input, [name]: value })
    };

    const HandleExhibitorsParticipants = (html) => {
        setInput({ ...input, exhibitors_and_participants: html });
    };

    // ---------------------------------------


    const handleSpeakerList = (e) => {
        const { name, value, files } = e.target;
        if (name === "photo") {
            setSpeakerList({
                ...speakerList,
                [name]: files[0],
            });
            validateField(name, files[0]);
        } else {
            setSpeakerList({
                ...speakerList,
                [name]: value,
            });
            validateField(name, value);
        }
    };

    // Validate individual fields
    const validateField = (name, value) => {
        let errorMsg = "";

        if (name === "name" && !value.trim()) {
            errorMsg = "Name is required.";
        } else if (name === "photo" && !value) {
            errorMsg = "logo is required.";
        }

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMsg,
        }));
    };

    // Validate the entire form
    const validateForm = () => {
        const newErrors = {};
        if (!speakerList.name.trim()) newErrors.name = "Name is required.";
        if (!speakerList.photo) newErrors.photo = "logo is required.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Add or update the speaker
    const handleAddSpeakerList = (e) => {
        e.preventDefault();

        if (!validateForm()) {
            console.log("Validation errors:", errors);
            return;
        }

        const newSpeaker = {
            exhibitor_name: speakerList.name,
            exhibitors: speakerList.photo,
        };

        if (normalEdit) {
            setExhibitorList((prevSponsors) =>
                prevSponsors.map((sponsor, index) =>
                    index === confirmedSponsorId ? newSpeaker : sponsor
                )
            );
            setNormalEdit(false);
        } else {
            setExhibitorList([...exhibitorList, newSpeaker]);
        }

        setSpeakerList({
            name: "",
            photo: null,
        });
        setErrors({});
    };

    const handleNormalEdit = (sponsor, id) => {
        const data = {
            name: sponsor?.exhibitor_name,
            logo: sponsor?.exhibitors
        }

        setSpeakerList(data);
        setConfirmedSponsorId(id);
        setNormalEdit(true);
    };

    const handleDeleteSpeaker = (indexToDelete) => {
        setExhibitorList((prevSponsors) =>
            prevSponsors.filter((_, index) => index !== indexToDelete)
        );
    };


    const HandleSubmit = async () => {
        const value = { ...input, exhibitor_list: exhibitorList }

        try {
            const response = await CreatePitchApi(eventId, value);
            console.log(response)

        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <div className="container-fluid">
                <div className='row'>
                    <div className="col-md-6">
                        <div className="col-md-12 mb-4">
                            <label className="form-label">
                                Programme Details<span className="asterisk">*</span>
                            </label>
                            <textarea
                                className="form-control"
                                type="text"
                                name="programme_details"
                                value={input?.programme_details}
                                onChange={handleOnchange}
                                placeholder="Enter Programme Details"
                                rows="8"
                            />
                        </div>


                        <div className="col-md-12 mb-4">
                            <label className="form-label">
                                Exhibitors and Participants<span className="asterisk">*</span>
                            </label>

                            <ReactQuill
                                theme="snow"
                                value={input?.exhibitors_and_participants}
                                onChange={HandleExhibitorsParticipants}
                                className="mt-2"
                                name='exhibitors_and_participants'
                                placeholder="Enter Exhibitors and Participants Details"
                            />
                        </div>

                        <div className="col-md-12">
                            <h4>Add Exhibitors List</h4>

                            <div className="row border-bottom">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                        Name<span className="asterisk">*</span>
                                    </label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="name"
                                        value={speakerList.name}
                                        onChange={handleSpeakerList}
                                        placeholder="Ex: Name"
                                    />
                                    {errors.name && <small className="text-danger">{errors.name}</small>}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                        Logo<span className="asterisk">*</span>
                                    </label>
                                    <input
                                        className="form-control"
                                        type="file"
                                        accept="image/*"
                                        name="photo"
                                        onChange={handleSpeakerList}
                                    />
                                    {errors.photo && <small className="text-danger">{errors.photo}</small>}
                                </div>



                                <div className="col-4 create-event-save-btn mb-3">
                                    <button
                                        type="button"
                                        onClick={handleAddSpeakerList}
                                    >
                                        {normalEdit ? 'Update' : 'Add'}
                                    </button>
                                </div>


                                {exhibitorList.length > 0 && (
                                    <div className="mt-3">
                                        <ul className="p-0">
                                            {exhibitorList?.map((list, index) => (
                                                <li
                                                    key={index}
                                                    className="d-flex justify-content-between gap-2 align-items-center mt-2 border py-2 px-4"
                                                >
                                                    <div className="d-flex gap-4 align-items-center">
                                                        <img
                                                            src={URL.createObjectURL(list?.exhibitors)}
                                                            alt={list.name}
                                                            className="border"
                                                            height='80px'
                                                            width='80px'
                                                        />
                                                        <p className="text-capitalize p-0 m-0">{list.exhibitor_name}</p>
                                                    </div>
                                                    <div className="d-flex gap-2 create-event-save-btn">
                                                        <button
                                                            className=""
                                                            type="button"
                                                            onClick={() => handleNormalEdit(list, index)}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            className=""
                                                            type="button"
                                                            onClick={() => handleDeleteSpeaker(index)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        </div>


                        {/* Save and Continue Button */}
                        <div className="d-flex justify-content-end gap-4 mt-5">
                            <div className="create-event-back-btn">
                                <button type="button">Back</button>
                            </div>
                            {exhibitorList?.length > 0 ?
                                <div className="create-event-save-btn">
                                    <button className="" onClick={HandleSubmit}> Save and Continue</button>
                                </div> :
                                <div className="create-event-save-btn">
                                    <button className="" onClick={() => alert("Add at least 1 Exhibitor List")}>Save and Continue</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>

            </div >
        </>
    )
}
export default Pitch;
